import * as React from "react";
import Box from "@mui/material/Box";
import {GoodRow, GoodRowData} from "./GoodRow.tsx";

interface GoodTableProps {
    data: GoodRowData[];
}

export const GoodTable: React.FC<GoodTableProps> = ({data}) => {

    return (
        <Box>
            {data && data.length > 0 && (
                data.map((row: GoodRowData) => (
                    <Box key={row.id}>
                        <GoodRow
                            {...row}
                        />
                    </Box>
                ))
            )}

        </Box>
    )
}